import React, { Component, PropTypes } from 'react'

import './Counter.scss'

class Counter extends Component {
  constructor (props) {
    super(props)
    this.state = {
      internalValue: this.props.input.value || this.props.min
    }

    this.decrement = this.decrement.bind(this)
    this.increment = this.increment.bind(this)
  }

  decrement () {
    const {
      input: {
        value,
        onChange
      },
      min,
      step
    } = this.props

    const newValue = Math.max(min, value - step)
    this.setState({internalValue: newValue})
    onChange(newValue)
  }

  increment () {
    const {
      input: {
        value,
        onChange
      },
      max,
      step
    } = this.props

    const newValue = Math.min(max, value + step)
    this.setState({internalValue: newValue})
    onChange(newValue)
  }

  render () {
    const {
      formatValue
    } = this.props
    const {
      internalValue
    } = this.state
    const value = formatValue(internalValue)
    return (
      <div className='Counter'>
        <button
          className='Counter-button Counter-decrementButton'
          type='button'
          onClick={this.decrement}>
          –
        </button>
        <div className='Counter-value'>{value}</div>
        <button
          className='Counter-button Counter-incrementButton'
          type='button'
          onClick={this.increment}>
          +
        </button>
      </div>
    )
  }
}

Counter.displayName = 'Counter'
Counter.propTypes = {
  input: PropTypes.object,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  formatValue: PropTypes.func
}
Counter.defaultProps = {
  min: 0,
  max: 99,
  step: 1,
  formatValue: value => value == null ? '' : value
}

export default Counter



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/Counter/Counter.js